import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FuseSharedModule } from '@fuse/shared.module';

import { DialogBoxPrintSectionComponent } from './print-section.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';

@NgModule({
    declarations: [
        DialogBoxPrintSectionComponent
    ],
    imports     : [
        BrowserAnimationsModule,
        FormsModule,
        MatTableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        FuseSharedModule,
        TranslateModule,
        MatSnackBarModule
    ],
    entryComponents: [
        DialogBoxPrintSectionComponent
    ]
})
export class PrintSectionModule
{
}
